export const RESPONSE_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};

export const RESPONSE_TABLE_COLUMNS = [
    { id: "DPD", isSortable: true, label: "DPD"},
    { id: "Message", isSortable: false, label: "Message"},
    { id: "MsgsSent", isSortable: true, label: "MsgsSent"},
    { id: "R1", isSortable: true, label: "R1"},
    { id: "AvgR", isSortable: true, label: "AvgR"},
    { id: "MaxR", isSortable: true, label: "MaxR"},
    { id: "R2", isSortable: true, label: "R2"},
    { id: "R3", isSortable: true, label: "R3"},
    { id: "R4", isSortable: true, label: "R4"},
    { id: "R5", isSortable: true, label: "R5"},
    { id: "R8", isSortable: true, label: "R8"},
    { id: "R10", isSortable: true, label: "R10"},
];

export const RESPONSE_TABLE_COLUMN_KEYS = {
    DPD: "DPD",
    MESSAGE: "Message",
    MSGS_SENT: "MsgsSent",
    R1: "R1",
    AVGR: "AvgR",
    MAXR: "MaxR",
    R2: "R2",
    R3: "R3",
    R4: "R4",
    R5: "R5",
    R8: "R8",
    R10: "R10",
};

export const RESPONSE_ERRORS = {
    FETCH_RESPONSE_ERROR: "Error fetching response data.",
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};